module.exports = __webpack_public_path__ + "files/20976218be0706def66a7cadffe4d4f6.png";